<app-scenario-selection [distanceID]="distanceID" [sectionName]="childName" [ShowDefault]="true"
  (forward)="finishSelection($event)">
</app-scenario-selection>
